/**
 * @generated SignedSource<<9d73611531fe258a1fd429813bb30e54>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedSimilarSoldItemsColumns_viewer$data = {
  readonly similarSoldItemsConnection: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly item: {
          readonly " $fragmentSpreads": FragmentRefs<"PdpSharedSimilarSoldItemsColumn_item">;
        } | null;
        readonly itemId: string | null;
        readonly soldDate: string | null;
      } | null;
    } | null> | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedSimilarSoldItemsColumn_viewer" | "useShouldShowSimilarSoldItems_viewer">;
  readonly " $fragmentType": "PdpSharedSimilarSoldItemsColumns_viewer";
};
export type PdpSharedSimilarSoldItemsColumns_viewer$key = {
  readonly " $data"?: PdpSharedSimilarSoldItemsColumns_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedSimilarSoldItemsColumns_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade"
    },
    {
      "kind": "RootArgument",
      "name": "itemId"
    },
    {
      "kind": "RootArgument",
      "name": "priceBookName"
    },
    {
      "kind": "RootArgument",
      "name": "userCountryCode"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedSimilarSoldItemsColumns_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedSimilarSoldItemsColumn_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useShouldShowSimilarSoldItems_viewer"
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 4
        },
        {
          "kind": "Variable",
          "name": "itemId",
          "variableName": "itemId"
        },
        {
          "kind": "Literal",
          "name": "requestSourceRole",
          "value": "BUYER"
        }
      ],
      "concreteType": "SimilarSoldItemsConnectionConnection",
      "kind": "LinkedField",
      "name": "similarSoldItemsConnection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SimilarSoldItemsConnectionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "SimilarSoldItemsNode",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "itemId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "soldDate",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Item",
                  "kind": "LinkedField",
                  "name": "item",
                  "plural": false,
                  "selections": [
                    {
                      "args": [
                        {
                          "kind": "Literal",
                          "name": "catchNonFatalErrors",
                          "value": false
                        },
                        {
                          "kind": "Variable",
                          "name": "isTrade",
                          "variableName": "isTrade"
                        },
                        {
                          "kind": "Variable",
                          "name": "priceBookName",
                          "variableName": "priceBookName"
                        },
                        {
                          "kind": "Variable",
                          "name": "userCountryCode",
                          "variableName": "userCountryCode"
                        },
                        {
                          "kind": "Variable",
                          "name": "userId",
                          "variableName": "userId"
                        }
                      ],
                      "kind": "FragmentSpread",
                      "name": "PdpSharedSimilarSoldItemsColumn_item"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "02aafe37c1da3221406ca2e76ec0f813";

export default node;
